quoteModule.factory("FinancedQuote", function() {
    var FinancedQuote = function() {
        this.financingInfo = {
            selectedPaymentTerm: null,
            eligibleTerms: [],
            downPayment: null,
            salesTaxNA : false,
            salesTaxAmount: null,
            calculatedData : {
                monthlyPayment: 0,
                financingTermMonths: 0,
                financingFeeAmount: 0,
                financedAmount: 0,
                docFee: 0,
            },
            accepted: false

        };
        this.calculationFinshed = false;
        this.productName = null;
        this.cost = 0;
        this.quoteId = null;
    };

    return FinancedQuote;
});